export default "__VITE_ASSET__1bcd0ac5__"